import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Card, Tooltip } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

export default function MarketingChannel({
  disabled, disabledTooltip, title, subtitle, icon, selected, signalIcon, signalText, onToggle
}) {
  const panel = (
    <Card
      className={classNames('mb-3', { 'clickable': !disabled, 'text-muted': disabled, 'panel-selected': selected })}
      style={{ borderRadius: '10px' }}
      onClick={disabled ? undefined : onToggle}
    >
      <Card.Body>
        <div className="d-flex align-items-center" style={{ gap: '20px' }}>
          <div className="icon-background">
            <div className={selected ? 'icon-gradient' : ''}>
              <FontAwesomeIcon fixedWidth={true} icon={icon} size="2xl"  />
            </div>
          </div>

          <div className="flex-grow-1">
            <div className="fw-semibold">{title}</div>
            <div>{subtitle}</div>
          </div>
          <div
            className="text-nowrap"
            style={{
              padding: '4px 8px',
              borderRadius: '24px',
              backgroundColor: '#DBDDDE',
              color: disabled ? '' : '#616366'
            }}
          >
            <small className="me-2">{signalText}</small>
            <span>
              <FontAwesomeIcon icon={signalIcon} size="lg" />
            </span>
          </div>
        </div>

      </Card.Body>
    </Card>
  );

  if (disabledTooltip) {
    const tooltipId = `channel-tooltip-${Math.floor(Math.random() * 100000)}`;
    return (
      <OverlayTrigger
        overlay={
          <Tooltip id={tooltipId}>
            {disabledTooltip}
          </Tooltip>
        }
        placement="top"
      >
        {panel}
      </OverlayTrigger>
    );
  }

  return panel;
}

MarketingChannel.propTypes = {
  disabled: PropTypes.bool,
  disabledTooltip: PropTypes.string,
  icon: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  signalIcon: PropTypes.object.isRequired,
  signalText: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  onToggle: PropTypes.func.isRequired
};
